<template>
  <div id="refactor-news">
    <header-menu :curType="infoType=='4'?4:1"></header-menu>
    <div>
      <img v-if="infoType != '4'" src="https://cdn.huimiaokeji.com/bj_hj@2x.png" alt="图片" style="width: 100%;">
      <img v-else src="https://cdn.huimiaokeji.com/bj_kh@2x.png" alt="图片" style="width: 100%;">
    </div>
    <!-- 新增内容区域 -->
    <div class="content-container">
      <!-- 上部分 -->
      <div class="info-title-container" v-if="infoType != '4'">
        <span>灰鲸资讯</span>
        <img src="https://cdn.huimiaokeji.com/icon_return_24@2x.png" alt="图片"
             style="width: 24px;vertical-align: middle;"/>
        <span>{{ getInfoTypeName(infoType) }}</span>
      </div>
      <!-- 新增的文章展示div -->
      <div class="article-content">
        <h1 class="article-title">{{ dataDetail.infoData.title }}</h1>
        <div class="article-meta"  v-if="infoType != '4'">
          <span class="article-time">{{ dataDetail.infoData.publishTime }}</span>
          <span class="article-views">浏览量: {{ dataDetail.infoData.pageViews }}</span>
        </div>
        <div class="article-meta" v-else>
          <span class="article-time">{{ dataDetail.infoData.createTime }}</span>
        </div>
        <div class="dashed-line"></div>
        <div class="article-body" v-html="dataDetail.infoData.content"></div>
      </div>
      <!-- 中间部分 - 推荐文章 -->
      <div class="middle-section" v-show="infoType != '4'">
        <h2 class="section-title">
          <span class="title-bar"></span>
          推荐阅读
        </h2>
        <div class="article-list">
          <div
              class="article-item"
              v-for="(item, index) in dataDetail.recData"
              :key="'rec-' + index"
              @click="goToDetails(item.infoId)"
          >
            {{ item.title || '暂无标题' }}
          </div>
        </div>
      </div>
      <!-- 下部分 - 热门文章 -->
      <div class="bottom-section" v-show="infoType != '4'">
        <h2 class="section-title">
          <span class="title-bar"></span>
          热门文章
        </h2>
        <div class="article-list">
          <div
              class="article-item"
              v-for="(item, index) in dataDetail.hotData"
              :key="'hot-' + index"
              @click="goToDetails(item.infoId)"
          >
            {{ item.title || '暂无标题' }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getDetailById, getCaseByCaseId } from '../../api/index.js';
import { aes } from '../../utils/crypto.js';

import HeaderMenu from "../../components/header-menu.vue";

export default {
  name: 'refactorDetails',
  components: {
    HeaderMenu
  },
  data() {
    return {
      dataDetail: {
        recData: [],
        hotData: [],
        infoData: {}
      },
      infoType: '0'
    }
  },
  computed: {
    infoId() {
      if (this.$route.query.infoId) {
        return this.$route.query.infoId;
      }
      return '0';
    },
  },
  created() {
    document.title = '灰鲸网络-资讯详情';
    //this.queryDetailInfo();
  },
  watch: {
    $route: {
      handler: function() {
        let decrypted = aes.decrypt(this.infoId);
        if (decrypted.includes(':')) {
          let infoId = decrypted.split(':')[0];
          this.infoType = decrypted.split(':')[1];
          if(this.infoType == '4'){
            this.qryCaseByCaseId(infoId);
          } else {
            this.queryDetailInfo(infoId);
          }
        }
      },
      immediate: true
    }
  },
  // mounted() {
  //   // 添加点击事件监听器，点击页面时创建meta标签
  //   this.clickHandler = this.createMetaTag.bind(this);
  //   document.addEventListener('click', this.clickHandler);
  // },
  // beforeUnmount() {
  //   // 移除点击事件监听器，防止内存泄漏
  //   document.removeEventListener('click', this.clickHandler);
  // },
  methods: {
    goToDetails(infoId) {
      const encrypted = aes.encrypt(infoId+':'+this.infoType);
      const url = `https://www.huimiaokeji.com/refactorDetails?infoId=${encodeURIComponent(encrypted)}`;
      window.open(url, '_blank');
    },
    // 获取资讯类型名称
    getInfoTypeName(type) {
      const typeMap = {
        '0': '公司动态',
        '1': '行业资讯',
        '2': '变现指南'
      };
      return typeMap[type] || '其他';
    },
    async qryCaseByCaseId(infoId) {
      let res = await getCaseByCaseId({caseId: infoId});
      if (res.code == 200) {
        this.dataDetail.infoData = res.data || {}
        if(this.dataDetail.infoData.seoDescription && this.dataDetail.infoData.seoKeywords){
          this.clickHandler = this.createMetaTag(this.dataDetail.infoData.seoDescription, this.dataDetail.infoData.seoKeywords);
          document.addEventListener('click', this.clickHandler);
        }
      } else {
        console.error('获取详情失败:', res);
      }
    },
    async queryDetailInfo(infoId) {
      let res = await getDetailById({infoId: infoId});
      if (res.code == 200) {
        this.dataDetail = res.data || {}
        if(this.dataDetail.infoData.seoTitle && this.dataDetail.infoData.seoKeywords){
          this.clickHandler = this.createMetaTag(this.dataDetail.infoData.seoTitle, this.dataDetail.infoData.seoKeywords);
          document.addEventListener('click', this.clickHandler);
        }
      } else {
        console.error('获取详情失败:', res);
      }
    },
    // 创建meta表情标签的方法
     createMetaTag(seoDescription, seoKeywords) {
      // 创建meta标签
      const metaDesc = document.createElement('meta');
       metaDesc.setAttribute('name', 'description');
       metaDesc.setAttribute('content', seoDescription || '😊 灰鲸网络客户案例页面 - 专业的智能变现解决方案');
      // 将meta标签添加到head中
      document.head.appendChild(metaDesc);
      const metaKeywords = document.createElement('meta');
      metaKeywords.setAttribute('name', 'keywords');
      metaKeywords.setAttribute('content', seoKeywords || 'keywords案例页面 - 专业的智能变现解决方案');
      // 将meta标签添加到head中
      document.head.appendChild(metaKeywords);
    }
  }
}
</script>

<style lang="less">
#refactor-news {
  background-color: #F3F7FF;

  /* 新增内容区域样式 */
  .content-container {
    margin: 80px 240px 50px 240px;
    display: flex;
    flex-direction: column;
    gap: 28px;
  }

  @media screen and (max-width: 980px) {
    .content-container {
      margin: 80px 100px 50px;
    }
  }

  .info-title-container {
    font-size: 16px;
    color: #8F9699;
    margin: 24px 0 0 0;
    text-align: left;
    font-weight: 500;
    line-height: 24px;
  }

  /* 新增的文章内容样式 */

  .article-content {
    background: #FFFFFF;
    padding: 0 40px 40px;
    //padding: 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    border-radius: 4px;
  }

  .article-title {
    font-size: 24px;
    font-weight: bold;
    color: #333333;
    margin-bottom: 16px;
    text-align: center; // 添加居中对齐
  }

  .article-meta {
    display: flex;
    gap: 20px;
    font-size: 14px;
    color: #999999;
    margin-bottom: 20px;
    justify-content: center;
  }

  .dashed-line {
    height: 1px;
    background: linear-gradient(to right, transparent, #EEF1F7, transparent);
    margin-bottom: 20px;
  }

  .article-body {
    font-size: 16px;
    line-height: 1.8;
    color: #333333;
    img {
      padding: 30px 0;
      max-width: 55%;
      height: auto;
      display: block;
      margin: 0 auto;
    }
  }

  /* 中间和下部分通用样式 */
  .middle-section,
  .bottom-section {
    background-color: white;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  }

  .section-title {
    font-size: 24px;
    font-weight: bold;
    color: #333;
    margin: 0 0 16px 0;
    padding-bottom: 8px;
    border-bottom: 1px solid #EEEEEE;
    display: flex;
    align-items: center;
    gap: 15px;
  }

  .title-bar {
    width: 10px;
    height: 24px;
    background: #0B00B5;
    border-radius: 5px;
  }

  .article-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .article-item {
    font-size: 14px;
    color: #333;
    padding: 12px;
    background-color: white;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.3s ease;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    // 新增样式：在前方添加8x8的灰色方块
    position: relative;
    padding-left: 32px; // 增加左内边距以容纳方块和间距
  }

  .article-item::before {
    content: '';
    position: absolute;
    left: 12px; // 与左侧保持原有的12px间距
    top: 50%;
    transform: translateY(-50%);
    width: 8px;
    height: 8px;
    background: #D8D8D8;
  }

  .article-item::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 1px;
    background-image: linear-gradient(to right, #ddd 50%, transparent 50%);
    background-size: 8px 1px;
    background-repeat: repeat-x;
  }

  .article-item:hover {
    background-color: #F8F9FF;
    color: #0B00B5;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/refactor/Details.vue